module.exports = __webpack_public_path__ + "img/image-03-sp.5d82e6c3.jpg";